export const styles = {
	layoutContainer: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
	},
	main: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
	},
}
